var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitepaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1976 19.2687L18.5616 12.9047C18.855 12.6112 18.855 12.1375 18.5616 11.844C18.2681 11.5506 17.7943 11.5506 17.5009 11.844L11.1369 18.208C9.47877 19.8662 6.78469 19.8662 5.12652 18.208C3.46836 16.5498 3.46836 13.8558 5.12652 12.1976L13.2583 4.06586C14.3295 2.9946 16.0761 2.9946 17.1473 4.06586C18.2186 5.13713 18.2186 6.88368 17.1473 7.95495L9.54594 15.5563C9.05804 16.0443 8.26608 16.0443 7.77817 15.5563C7.29027 15.0684 7.29027 14.2765 7.77817 13.7886L14.6725 6.89429C14.9659 6.60084 14.9659 6.12708 14.6725 5.83363C14.379 5.54018 13.9053 5.54018 13.6118 5.83363L6.71751 12.7279C5.64625 13.7992 5.64625 15.5457 6.71751 16.617C7.78878 17.6883 9.53534 17.6883 10.6066 16.617L18.208 9.01561C19.8662 7.35745 19.8662 4.66337 18.208 3.0052C16.5498 1.34704 13.8558 1.34704 12.1976 3.0052L4.06586 11.1369C1.82434 13.3785 1.82434 17.0271 4.06586 19.2687C6.30739 21.5102 9.95606 21.5102 12.1976 19.2687Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaperIcon);
export default __webpack_public_path__ + "static/media/whitepaper-icon.3d0f362c3ad29001a98cd2eb6957b8d0.svg";
export { ForwardRef as ReactComponent };